import type { FC } from 'react'
import { useContext, useState } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextAreaInput from '@/components/input/TextAreaInput'
import ctx from '@/context/AppContext'
import { useRemoveIncomeMutation } from '@/lib/apollo'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

const TextContainer = styled.div`
  margin-top: 15px;
`

interface Props {
  customerId: string
  subjectId: string
  incomeId: string
  onClose: () => void
}

const RemoveIncomeSidebar: FC<Props> = ({ customerId, subjectId, incomeId, onClose }) => {
  const [error, setError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [reason, setReason] = useState<string>('')

  const { token, personId } = useContext(ctx)

  const [handleRemoveIncome] = useRemoveIncomeMutation()

  const onSubmit = async () => {
    setError(undefined)
    setLoading(true)

    try {
      await handleRemoveIncome({
        variables: {
          token: token ?? '',
          customerId,
          subjectId,
          incomeId,
          reason,
          userId: personId ?? '',
        },
      })

      setSuccess(true)
    } catch (e) {
      setError('An unexpected error occurred.')
    }

    setLoading(false)
  }

  return (
    <SlideInSidebar
      onClose={onClose}
      header={
        <div>
          <h2>Remove Income</h2>
        </div>
      }
      content={
        success ? (
          <>
            The income was successfully removed. The income will be removed from this page
            within the next few seconds.
          </>
        ) : (
          <>
            This action will remove the record of this income from the application. Please
            provide your reason for removing this income and click confirm below.{' '}
            <strong>Warning: this action cannot be undone!</strong>
            <TextContainer>
              <TextAreaInput
                label="Please specify why you are removing this income"
                onChange={(e: any) => {
                  setReason(e.target.value)
                }}
                value={reason}
              />
            </TextContainer>
          </>
        )
      }
      footer={
        <>
          {error && <ErrorContainer>{error}</ErrorContainer>}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!success && (
              <Button disabled={loading} onClick={onSubmit}>
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default RemoveIncomeSidebar
